<template>
  <DialogContent>
    <Spinner :size="30" class="mx-auto mb-2" />
    <div class="font-primary text-[14px] text-center">
      Processing your download...
    </div>
  </DialogContent>
</template>

<script setup lang="ts">
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import Spinner from '@/shared/components/Spinner.vue'
import { useDownloadMutation } from '@/shared/graphql/legacy/generated'
import type { File } from '@/shared/graphql/router/graphql'
import { downloadURLContent } from '@/shared/utils/url'
import { onMounted } from 'vue'

const { close } = useDialog()

const props = defineProps<{
  file: File
}>()

const { mutate: downloadFile } = useDownloadMutation()

onMounted(async () => {
  const result = await downloadFile({
    id: props.file.id,
  })

  const url = result?.data?.download

  if (!url) return

  downloadURLContent(props.file.metadata.originalFilename, url)

  close()
})
</script>
